import React from 'react';

import Wizard from '././../DegreeDocumentPrint/Wizard';

export default () => <Wizard admin />;



// WEBPACK FOOTER //
// ./src/views/Admin/LockedStudents.js